<h3 mat-dialog-title>Opt In / Out of Cross-selling Opportunities</h3>
<section mat-dialog-content>
  <div class="tw-pt-5">Select whether this contact has opted in or out of cross-selling opportunities.</div>
  <div class="tw-pt-5 tw-pb-2">
    <mat-radio-group [(ngModel)]="currentValue">
      <mat-radio-button [value]="'1'" class="tw-mr-6">Opted In</mat-radio-button>
      <mat-radio-button [value]="'0'">Opted Out</mat-radio-button>
    </mat-radio-group>
  </div>
</section>
<section mat-dialog-actions class="tw-justify-end">
    <button mat-flat-button (click)="closeModal()" class="button cancel">Cancel</button>
    <button mat-flat-button (click)="handleSave()" class="button save tw-mr-2" [disabled]="updateInProgress">{{ updateInProgress ? 'Saving...' : 'Save' }}</button>
</section>


